import {CroppingSystemModel} from 'library/src/crops/models/CroppingSystemModel';
import {CropsTypeModel} from 'library/src/crops/models/CropsTypeModel';
import {all, call, delay, put, takeEvery, takeLatest} from 'redux-saga/effects';
import {fetchError, fetchStart, fetchSuccess} from 'shared/actions/Common';
import {timeoutDuration} from 'shared/configs/AppConst';
import api, {pixagriApiUrl, wagoNestApiUrl} from 'shared/services/ApiConfig';
import {appIntl} from 'shared/utils/IntlGlobalProvider';
import actions, {
  ADD_NEW_CROP,
  AddNewCropAction,
  DELETE_CROP,
  DeleteCropAction,
  LOAD_CROPS_LISTING,
  MODIFY_CROP,
  ModifyCropAction,
} from '../actions/CropsActions';
import getCropFromNameMatch from '../configs/CropIconsConfig';
import CropModel from '../models/CropModel';
function getCropsListingRequest() {
  const cropsUrl = `${pixagriApiUrl}/crops`;
  return api.get(cropsUrl);
}

function getCropsTypesRequest() {
  const url = `${wagoNestApiUrl}/crops`;
  return api.get(url);
}
function getCroppingSystemRequest() {
  const url = `${wagoNestApiUrl}/crops/cropping-systems`;
  return api.get(url);
}
function* loadCropsListing() {
  try {
    yield put(fetchStart('loadCropsListing'));
    const res = yield call(getCropsListingRequest);
    const cropsListing = res.data as CropModel[];
    const cropsMap: {[key: string]: CropModel} = {};
    cropsListing.forEach((value) => {
      if (value.crop_id !== undefined) {
        cropsMap[value.crop_id] = {
          ...value,
          crop_icon: getCropFromNameMatch(value.crop_name),
        };
      }
    });

    const cropsTypes = yield call(getCropsTypesRequest);
    const cropsTypesMap: {[key: number]: CropsTypeModel} = {};
    cropsTypes.data.forEach((type) => {
      if (type.id !== undefined) {
        cropsTypesMap[type.id] = type;
      }
    });
    const croppingSystems = yield call(getCroppingSystemRequest);
    const croppingSystemsMap: {[key: number]: CroppingSystemModel} = {};
    croppingSystems.data.forEach((system) => {
      if (system.id !== undefined) {
        croppingSystemsMap[system.id] = system;
      }
    });
    yield put(actions.loadCropsListingSuccessAction(cropsMap, cropsTypesMap, croppingSystemsMap));
    //yield put(actions.getCropTypesSuccess(cropsTypesMap));
    yield put(fetchSuccess('loadCropsListing'));
  } catch (error: any) {
    yield put(fetchError('loadCropsListing', error.message));
  }
}

function addNewCropRequest(newCrop: CropModel) {
  const cropUrl = `${pixagriApiUrl}/crops`;
  return api.post(cropUrl, newCrop);
}

function* addNewCrop(action: AddNewCropAction) {
  try {
    yield put(fetchStart('addNewCrop'));
    const newCrop: CropModel = action.payload;
    const {farmerIdsList, ...newCropToSend} = newCrop;
    if (!farmerIdsList || !farmerIdsList.length) {
      yield call(addNewCropRequest, newCropToSend);
    } else {
      for (let id of farmerIdsList) {
        const cropForFarmer: CropModel = {
          ...newCropToSend,
          farmer_id: id,
        };
        yield call(addNewCropRequest, cropForFarmer);
      }
    }

    yield put(fetchSuccess('addNewCrop'));

    yield call(reloadCropsListingAfterDelay);
  } catch (error: any) {
    yield put(fetchError('addNewCrop', error.message));
  }
}

function deleteCropRequest(selectedCrop: number) {
  const cropUrl = `${pixagriApiUrl}/crops/${selectedCrop}`;
  return api.delete(cropUrl);
}

function* deleteCrop(action: DeleteCropAction) {
  try {
    yield put(fetchStart('deleteCrop'));
    yield call(deleteCropRequest, action.payload);
    yield put(fetchSuccess('deleteCrop'));

    yield call(reloadCropsListingAfterDelay);
  } catch (error: any) {
    let errorMessage = error.message;
    if (error.response && error.response.status === 409) {
      errorMessage = appIntl().formatMessage({id: 'crops.delete.error409'});
    }
    yield put(fetchError('deleteCrop', errorMessage));
  }
}

function modifyCropRequest(modifiedCrop: CropModel) {
  const selectedCrop: number | undefined = modifiedCrop.crop_id;
  const cropUrl = `${pixagriApiUrl}/crops/${selectedCrop}`;
  return api.put(cropUrl, modifiedCrop);
}

function* modifyCrop(action: ModifyCropAction) {
  try {
    yield put(fetchStart('modifyCrop'));
    yield call(modifyCropRequest, action.payload);
    yield put(fetchSuccess('modifyCrop'));

    yield call(reloadCropsListingAfterDelay);
  } catch (error: any) {
    yield put(fetchError('modifyCrop', error.message));
  }
}

function* reloadCropsListingAfterDelay(delayMultiplier: number = 1) {
  // Wait for some times
  yield delay(timeoutDuration * delayMultiplier);

  //reload crops
  yield put(actions.loadCropsListing());
}

export function* cropsSagas() {
  yield all([
    takeLatest(LOAD_CROPS_LISTING, loadCropsListing),
    takeEvery(ADD_NEW_CROP, addNewCrop),
    takeEvery(DELETE_CROP, deleteCrop),
    takeEvery(MODIFY_CROP, modifyCrop),
  ]);
}
